import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

// Hook to embed a confirmation dialog in any functional component
export const useDialog = ({ title = "", body = "", children = null, cancelText = "Cancel", confirmText = "OK" }) => {
  const [open, setOpen] = useState(false);
  const [callback, setCallback] = useState(false);

  const toggleOpen = (callbackFn = null) => {
    setCallback(callbackFn);
    setOpen(!open);
  };

  const closeWithCallBack = () => {
    toggleOpen();
    callback();
  };

  const dialog = (
    <Dialog
      open={open}
      onClose={toggleOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{body}</DialogContentText>
        {children}
      </DialogContent>
      <DialogActions>
        {cancelText &&
          <Button onClick={toggleOpen}>{cancelText}</Button>
        }
        {confirmText &&
          <Button onClick={closeWithCallBack} autoFocus>
            {confirmText}
          </Button>
        }
      </DialogActions>
    </Dialog>
  );

  return [toggleOpen, dialog];
};
